<div class="row">
  <div class="col-sm-12 my-3">
    <div class="card w-100">
      <div class="card-body d-flex align-items-center justify-content-between">
        <div class="card-title m-0 d-flex align-items-center h5">
          <i-feather
            name="{{ data.icon }}"
            class="bergh-text-secondary icon mr-3"
          ></i-feather>
          {{ data.title }}
          {{
            type === "Project Details"
              ? ""
              : type === "QR"
              ? ""
              : "(" + data.countTwo + ")"
          }}
        </div>
        <span class="buttons-collection d-flex">
          @for (button of data.buttons; track button; let i = $index) {
          <button
            class="btn btn-outline bergh-btn-outline-primary {{
              button.class ? button.class : ''
            }}"
            (click)="changeState(i)"
            id="topBarBtn-{{ i }}"
          >
            {{ button.text }}
          </button>
          }
        </span>
      </div>
    </div>
  </div>
</div>
